import { selectCurrentRoles } from "features/auth/authSlice";
import { useEffect, useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap";
import swal from "sweetalert";
import img1 from "../../assets/images/default.jpg";
import pdfimg from "../../assets/images/pdf-img.jpg";
import {
  useGetSathiAgreementFormQuery,
  useGetSathiDetailsbyIdQuery,
  useRegenerateSaathiFormQuery,
} from "./SaathiApiSlice";
import SaathiBankDetails from "./SaathiBankDetails";
import SaathiBusinessDetails from "./SaathiBusinessDetails";
import SaathiCertificationDetails from "./SaathiCertificationDetails";
import SaathiCheckerMaker from "./SaathiCheckerMaker";
import SaathiEducationDetails from "./SaathiEducationDetails";
import SaathiPersonalDetailsEdit from "./SaathiPersonalDetailsEdit";
import SaathiUploadAgreement from "./SaathiUploadAgreement";
import { setBreadcrumbs } from "app/appSlice";

const SaathiViewDetails = () => {
  const RolesFromToken = useSelector(selectCurrentRoles);
  const [SaathiUserData, setSaathiUserData] = useState({});

  const { id } = useParams();
  const [isEffects, setisEffects] = useState(false);

  const [showPdf, setPdf] = useState();
  const [Saathipdf, setSaathipdf] = useState(false);
  const [loader, setLoader] = useState(false);
  const [regenerateUrl, setRegenerateUrl] = useState("");
  const [genratedurl, setgenratedurl] = useState(false);
  const [showFinalimage, setShowFinalImage] = useState({});
  const agreed =
    SaathiUserData !== undefined ? SaathiUserData.is_agreed : "false";

  const [activeTab, setactiveTab] = useState(1);

  const Saathipdf_edit = (index) => {
    setSaathipdf(!Saathipdf);
    setSaathipdf((prevSaathipdf) => ({
      [index]: !prevSaathipdf[index],
    }));
  };

  const {
    data: data,
    refetch: SaathiDetailsRefetch,
  } = useGetSathiDetailsbyIdQuery(id, { refetchOnMountOrArgChange: true });

  const {
    data: generateAgreement,
    refetch: refetchSathiAgreementForm,
  } = useGetSathiAgreementFormQuery(id);

  const {
    data: regenerateSaathiForm,
    refetch: refetchForm,
  } = useRegenerateSaathiFormQuery(id);

  const genrateAgreementForm = () => {
    setLoader(true);
    refetchForm()
      .unwrap()
      .then((res) => {
        if (res.status === 200) {
          swal("Success", {
            buttons: false,
            icon: "success",
            title: "Agreement Generated",
            timer: 1000,
          });
          setLoader(false);
          setgenratedurl(true);
          setRegenerateUrl(res?.data?.empanelment_form_url);
        } else {
          swal("Error", res.message, "error");
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    const dataFromApi = data?.data ? data?.data : [];
    setSaathiUserData(dataFromApi);
  }, [data]);

  const dispatch = useDispatch();
  useEffect(() => {
    const breadcrumbs = [
      { name: "Dashboard", link: "/dashboard" },
      { name: "Saathi", link: "/onboarding/agrani-saathi" },
      { name: id, link: "" },
    ];

    dispatch(setBreadcrumbs(breadcrumbs));
  }, [data]);

  return (
    <div className="margin_top">
      <Container fluid>
        <Col sm="12" className="">
          <Card className="mb-0">
            <CardBody className="p-2 p-lg-4">
              <Row className="">
                <ul>
                  <Nav fill pills className="gap-1">
                    <NavItem>
                      <NavLink
                        className={
                          activeTab === 1 ? "ColouredClass" : "basicNavClass"
                        }
                        onClick={() => {
                          setactiveTab(1);
                        }}
                      >
                        <h5>Basic Details</h5>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={
                          activeTab === 2 ? "ColouredClass" : "basicNavClass"
                        }
                        onClick={() => {
                          setactiveTab(2);
                        }}
                      >
                        <h5>Education & Banking</h5>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={
                          activeTab === 3 ? "ColouredClass" : "basicNavClass"
                        }
                        onClick={() => {
                          setactiveTab(3);
                        }}
                      >
                        <h5> Certifications and Business Details</h5>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={
                          activeTab === 4 ? "ColouredClass" : "basicNavClass"
                        }
                        onClick={() => {
                          setactiveTab(4);
                        }}
                      >
                        <h5>Documents</h5>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </ul>
              </Row>
              <div className="">
                <TabContent
                  activeTab={activeTab}
                  style={{ padding: "1rem", border: "none" }}
                >
                  <TabPane tabId={1}>
                    <SaathiPersonalDetailsEdit
                      SaathiUserData={SaathiUserData}
                      SaathiDetailsRefetch={SaathiDetailsRefetch}
                    />
                  </TabPane>
                  <TabPane tabId={2} style={{ padding: "0.5rem" }}>
                    <div>
                      <SaathiEducationDetails
                        SaathiUserData={SaathiUserData}
                        SaathiDetailsRefetch={SaathiDetailsRefetch}
                      />
                      <SaathiBankDetails
                        SaathiUserData={SaathiUserData}
                        SaathiDetailsRefetch={SaathiDetailsRefetch}
                      />
                    </div>
                  </TabPane>
                  <TabPane tabId={3} style={{ padding: "0.5rem" }}>
                    <SaathiCertificationDetails
                      SaathiUserData={SaathiUserData}
                    />
                    <SaathiBusinessDetails
                      SaathiUserData={SaathiUserData}
                      SaathiDetailsRefetch={SaathiDetailsRefetch}
                    />
                  </TabPane>
                  <TabPane tabId={4}>
                    <Row>
                      {SaathiUserData?.all_media?.length > 0 ? (
                        <Col lg={10} className="mb-2">
                          <div className="popup-gallery d-flex flex-wrap">
                            {SaathiUserData !== undefined &&
                            SaathiUserData.all_media !== null
                              ? SaathiUserData.all_media &&
                                SaathiUserData.all_media.map((list, index) =>
                                  list.file !== "object" ? (
                                    list.file_extension === ".png" ||
                                    list.file_extension === ".jpeg" ||
                                    list.file_extension === ".jpg" ? (
                                      <Col lg={2} key={index}>
                                        <Card className="text-center border ">
                                          <CardBody style={{ padding: "1rem" }}>
                                            <div className="img-fluid float-left">
                                              <small className="mb-1 text-uppercase">
                                                {list.document_type ===
                                                "Police Verification Certificate"
                                                  ? "Police Certificate"
                                                  : list.document_type}
                                              </small>
                                              <hr className="mt-2" />

                                              {list.filename === null ||
                                              list.filename === undefined ||
                                              list.filename.length === 0 ? (
                                                "No Image Found"
                                              ) : (
                                                <img
                                                  src={img1}
                                                  onClick={(e) => {
                                                    setisEffects(true);
                                                    setShowFinalImage(
                                                      list.filename
                                                    );
                                                  }}
                                                  className="img-fluid"
                                                />
                                              )}
                                            </div>
                                          </CardBody>
                                        </Card>
                                      </Col>
                                    ) : (
                                      <Col lg={2} key={index}>
                                        <Card className="text-center border ">
                                          <CardBody style={{ padding: "1rem" }}>
                                            <div className="img-fluid float-left">
                                              <small className="mb-1 text-uppercase">
                                                {list.document_type}
                                              </small>
                                              <hr className="mt-2" />
                                              <img
                                                src={pdfimg}
                                                style={{ width: "53%" }}
                                                aria-controls="userDetails"
                                                data-toggle="modal"
                                                data-target="#userDetails"
                                                onClick={(e) => {
                                                  setSaathipdf(true);
                                                  setPdf(list.filename);
                                                }}
                                                className=""
                                              />
                                            </div>
                                          </CardBody>
                                        </Card>
                                      </Col>
                                    )
                                  ) : (
                                    "NO Document Uploaded Yet"
                                  )
                                )
                              : null}
                          </div>
                        </Col>
                      ) : (
                        <Col>
                          <h4>No Documents Uploaded yet</h4>
                        </Col>
                      )}

                      {SaathiUserData.is_agreed === true ? (
                        <>
                          <Col lg={2}>
                            <Card className="text-center border ">
                              <CardBody className="p-4">
                                <div className="img-fluid float-left">
                                  <button
                                    className="btn btn-primary text-white p-2"
                                    onClick={genrateAgreementForm}
                                  >
                                    Re-generate Agreement &nbsp;
                                    {loader ? (
                                      <Spinner
                                        animation="border"
                                        size="sm"
                                      ></Spinner>
                                    ) : (
                                      ""
                                    )}
                                  </button>

                                  {genratedurl == true ? (
                                    <>
                                      <hr className="mt-2" />
                                      <a
                                        href={regenerateUrl}
                                        className="img-fluid text-decoration-none text-primary"
                                      >
                                        Download{" "}
                                        <span className="mdi mdi-download"></span>
                                      </a>
                                    </>
                                  ) : null}
                                </div>
                              </CardBody>
                            </Card>
                            {SaathiUserData.is_attached_by_agent === true ? (
                              <Card className="text-center border ">
                                <CardBody className="p-3">
                                  <div className="img-fluid float-left">
                                    <small className="mb-1 text-uppercase">
                                      Agreed Doc
                                    </small>

                                    <hr className="mt-2" />
                                    <a
                                      href={SaathiUserData.attached_form_link}
                                      target="_black"
                                      className="img-fluid text-decoration-none text-primary"
                                    >
                                      Signed Agreement{" "}
                                      <span className="mdi mdi-download"></span>
                                    </a>
                                  </div>
                                </CardBody>
                              </Card>
                            ) : null}
                          </Col>
                        </>
                      ) : null}

                      {agreed == true &&
                      SaathiUserData.is_attached_by_agent == false &&
                      RolesFromToken.groups?.includes("Maker") ? (
                        <Row className="mb-3">
                          <SaathiUploadAgreement
                            SaathiUserData={SaathiUserData}
                            refetch={SaathiDetailsRefetch}
                          />
                        </Row>
                      ) : (
                        ""
                      )}

                      {SaathiUserData.is_agreed !== true &&
                      RolesFromToken.groups?.includes("Maker") ? (
                        <>
                          {/* <Col lg={12}>
                            <Card className="text-center border ">
                              <CardBody className="p-4">
                              
                                <SaathiAgreement />
                              </CardBody>
                            </Card>
                          </Col> */}
                          <h6> *** Terms and Conditions is pending</h6>
                        </>
                      ) : null}
                      {isEffects ? (
                        <Lightbox
                          image={showFinalimage}
                          onClose={() => {
                            setisEffects(!isEffects);
                          }}
                        />
                      ) : null}

                      {/* Model for pdf */}
                      <Modal
                        size="xl"
                        isOpen={Saathipdf}
                        toggle={() => {
                          Saathipdf_edit();
                        }}
                      >
                        <div className="modal-header bg-warning">
                          <h5 className="modal-title " id="">
                            Documents
                          </h5>
                          <button
                            type="button"
                            onClick={(e) => {
                              setSaathipdf(false);
                            }}
                            style={{ borderRadius: "5px" }}
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <iframe
                            src={showPdf !== undefined ? showPdf : pdfimg}
                            width="100%"
                            height="520"
                          ></iframe>
                        </div>
                      </Modal>
                    </Row>

                    {RolesFromToken.groups.includes("Maker") ||
                    RolesFromToken.groups.includes("Checker") ? (
                      <div className="">
                        <SaathiCheckerMaker
                          SaathiDetail={SaathiUserData.onboarding_status}
                          refetch={SaathiDetailsRefetch}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </TabPane>
                </TabContent>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Container>
    </div>
  );
};

export default SaathiViewDetails;
